//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
	display: flex;
	flex-direction: ${({ direction = "row" }) => direction};
	flex-wrap: wrap;
	gap: 10px;
	align-items: ${({ align = "center" }) => align};
	border-radius: 8px;
	background-color: var(--light-1);
	border: 1px solid var(--light-blue-3);
	padding: 15px 25px;
	width: 55%;
	@media (max-width: 1215px) {
		width: 60%;
	}
	@media (max-width: 1200px) {
		width: 80%;
	}
	@media (max-width: 1000px) {
		width: 90%;
	}
`;
export const Description = styled.p`
	margin: 0;
	font-size: 14px;
	color: var(--purple-6);
`;
export const Title = styled.h4`
	font-size: 14px;
	margin: 0;
	font-weight: ${({ weight = "400" }) => weight};
	color: var(--dark-4);
`;
export const Subtitle = styled.h5`
	font-size: 12px;
	color: var(--dark-4);
	margin: 0;
`;
export const DividerTitle = styled.span`
	color: var(--purple-4);
`;
